// extracted by mini-css-extract-plugin
export default {"resizableImageContainer":"TiptapImage_resizableImageContainer__r4Iki","resizableImage":"TiptapImage_resizableImage__I4HU4"};